import { parsePhoneNumberWithError } from 'libphonenumber-js';

const validPhoneNumber = (str = '') => {
	try {
		const phoneNumber = parsePhoneNumberWithError(`+${str.replace(/^\+/, '')}`);
		return (phoneNumber && phoneNumber.isValid()) || false;
	} catch (error) {
		return false;
	}
};

export default validPhoneNumber;
